<mat-tree #tree class="c-mat-tree" [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding matTreeNodePaddingIndent="10px"
    class="{{keyActive === node.data.id ? 'node-active' : 'node-hover'}}" (click)="clickNode(node)">
    <!-- <button mat-icon-button disabled></button> -->
    <div class="d-flex justify-content-between w-100">
      <!-- <mat-checkbox class="checklist-leaf-node align-self-center" [checked]="checklistSelection.isSelected(node)"
        (change)="todoLeafItemSelectionToggle(node)">{{node.data.name}}</mat-checkbox> -->
      <span class="align-self-center">

        <container-element [ngSwitch]="node.data.data_type">
          <i *ngSwitchCase="'table'" class="fa-solid fa-table text-primary me-1"></i>
          <i *ngSwitchCase="'html'" class="fa-solid fa-code text-danger me-1"></i>
          <i *ngSwitchCase="'xlsx'" class="fa-regular fa-file-excel text-success me-1"></i>
          <i *ngSwitchCase="'exe'" class="fa-brands fa-windows text-primary me-1"></i>
          <i *ngSwitchCase="'jpg'" class="fa-regular fa-image text-primary me-1"></i>
          <i *ngSwitchCase="'png'" class="fa-regular fa-image text-primary me-1"></i>
          <i *ngSwitchCase="'shp'" class="fa-solid fa-road me-1 text-danger"></i>
          <i *ngSwitchCase="'map'" class="fa-solid fa-map-location-dot me-1 text-warning"></i>
          <i *ngSwitchCase="'txt'" class="fa-regular fa-file-lines me-1 text-muted"></i>
          <i *ngSwitchCase="'pdf'" class="fa-solid fa-file-pdf me-1 text-success"></i>
          <i *ngSwitchCase="'folder'" class="fa-solid fa-folder me-1 text-warning"></i>
          <i *ngSwitchDefault class="fa-regular fa-file me-1 text-muted"></i>
        </container-element>
        <span>{{node.data.name}}</span>
      </span>

      <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
        <i class="fa-solid fa-ellipsis"></i>
      </button>
      <mat-menu #menu="matMenu">
        <div *ngIf="node.data.data_type === 'folder'">
          <button mat-menu-item (click)="createFolder(node.data, 'folder')" [role]="buttons.ADD.VALUE">
            <i class="fa-solid fa-folder-plus font-size-16 text-warning me-2"></i>
            <span>Tạo thư mục</span>
          </button>
          <!-- <button mat-menu-item (click)="createFolder(node.data, 'service')">
            <i class="fa-solid fa-database font-size-16 text-primary me-2"></i>
            <span>Tạo service</span>
          </button> -->
          <button mat-menu-item (click)="createFolder(node.data, 'map')" [role]="buttons.ADD.VALUE">
            <i class="fa-solid fa-map-location-dot font-size-16 text-danger me-2"></i>
            <span>Tạo map</span>
          </button>
          <button mat-menu-item (click)="createFolder(node.data, 'table')" [role]="buttons.ADD.VALUE">
            <i class="fa-solid fa-table font-size-16 text-secondary me-2"></i>
            <span>Tạo bảng</span>
          </button>
          <button mat-menu-item disabled>
            <i class="fa-solid fa-user-plus font-size-16 text-secondary me-2"></i>
            <span>Chia sẻ</span>
          </button>
          <button mat-menu-item (click)="renameFolder(node.data)">
            <i class="fa-solid fa-pen font-size-16 text-primary me-2"></i>
            <span>Đổi tên</span>
          </button>
          <button mat-menu-item (click)="deleteFolder(node.data)" [role]="buttons.DELETE.VALUE">
            <i class="fa-regular fa-trash-can font-size-16 text-delete me-2"></i>
            <span>Xóa</span>
          </button>
        </div>
        <div *ngIf="node.data.data_type !== 'folder'">
          <button mat-menu-item>
            <i class="fa-regular fa-eye font-size-16 text-secondary me-2"></i>
            <span>Mở</span>
          </button>
          <button mat-menu-item disabled>
            <i class="fa-solid fa-user-plus font-size-16 text-secondary me-2"></i>
            <span>Chia sẻ</span>
          </button>
          <button mat-menu-item (click)="renameFolder(node.data)">
            <i class="fa-solid fa-pen font-size-16 text-primary me-2"></i>
            <span>Đổi tên</span>
          </button>
          <button mat-menu-item (click)="deleteFolder(node.data)" [role]="buttons.DELETE.VALUE">
            <i class="fa-regular fa-trash-can font-size-16 text-delete me-2"></i>
            <span>Xóa</span>
          </button>
        </div>

      </mat-menu>
    </div>
  </mat-tree-node>

  <!-- <mat-tree-node *matTreeNodeDef="let node; when: hasNoContent" matTreeNodePadding>
    <button mat-icon-button disabled></button>
    <mat-form-field appearance="fill">
      <mat-label>New item...</mat-label>
      <input matInput #itemValue placeholder="Ex. Lettuce" />
    </mat-form-field>
    <button mat-button (click)="saveNode(node, itemValue.value)">Save</button>
  </mat-tree-node> -->

  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="10px"
    class="{{keyActive === node.data.id ? 'node-active' : 'node-hover'}}" (click)="clickNode(node)">
    <div class="d-flex justify-content-between w-100">
      <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.code" (click)="clickNode(node)">
        <i *ngIf="!treeControl.isExpanded(node)" class="fa-solid fa-caret-right me-2"></i>
        <i *ngIf="treeControl.isExpanded(node)" class="fa-solid fa-sort-down me-2"></i>
        <span>
          <i class="fa-solid fa-folder text-warning me-1"></i>
          <span>{{node.data.name}}</span>
        </span>
      </button>

      <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
        <i class="fa-solid fa-ellipsis"></i>
      </button>
      <mat-menu #menu="matMenu">
        <div *ngIf="node.data.data_type === 'folder'">
          <button mat-menu-item (click)="createFolder(node.data, 'folder')" [role]="buttons.ADD.VALUE">
            <i class="fa-solid fa-folder-plus font-size-16 text-warning me-2"></i>
            <span>Tạo thư mục</span>
          </button>
          <!-- <button mat-menu-item (click)="createFolder(node.data, 'service')">
            <i class="fa-solid fa-database font-size-16 text-primary me-2"></i>
            <span>Tạo service</span>
          </button> -->
          <button mat-menu-item (click)="createFolder(node.data, 'map')" [role]="buttons.ADD.VALUE">
            <i class="fa-solid fa-map-location-dot font-size-16 text-danger me-2"></i>
            <span>Tạo map</span>
          </button>
          <button mat-menu-item (click)="createFolder(node.data, 'table')" [role]="buttons.ADD.VALUE">
            <i class="fa-solid fa-table font-size-16 text-secondary me-2"></i>
            <span>Tạo bảng</span>
          </button>
          <button mat-menu-item disabled>
            <i class="fa-solid fa-user-plus font-size-16 text-secondary me-2"></i>
            <span>Chia sẻ</span>
          </button>
          <button mat-menu-item (click)="renameFolder(node.data)">
            <i class="fa-solid fa-pen font-size-16 text-primary me-2"></i>
            <span>Đổi tên</span>
          </button>
          <button mat-menu-item (click)="deleteFolder(node.data)" [role]="buttons.DELETE.VALUE">
            <i class="fa-regular fa-trash-can font-size-16 text-delete me-2"></i>
            <span>Xóa</span>
          </button>
        </div>
        <div *ngIf="node.data.data_type !== 'folder'">
          <button mat-menu-item disabled>
            <i class="fa-regular fa-eye font-size-16 text-secondary me-2"></i>
            <span>Mở</span>
          </button>
          <button mat-menu-item disabled>
            <i class="fa-solid fa-user-plus font-size-16 text-secondary me-2"></i>
            <span>Chia sẻ</span>
          </button>
          <button mat-menu-item (click)="renameFolder(node.data)">
            <i class="fa-solid fa-pen font-size-16 text-primary me-2"></i>
            <span>Đổi tên</span>
          </button>
          <button mat-menu-item (click)="deleteFolder(node.data)" [role]="buttons.DELETE.VALUE">
            <i class="fa-regular fa-trash-can font-size-16 text-delete me-2"></i>
            <span>Xóa</span>
          </button>
        </div>

      </mat-menu>

      <!-- <div class="more-action d-flex">
        <div class="dropdown d-inline-block " ngbDropdown>
          <button type="button" mat-icon-button ngbDropdownToggle id="page-header-user-dropdown">
            <i class="fa-solid fa-ellipsis cursor-pointer"></i>
          </button>
          <div class="d-dropdown-left" ngbDropdownMenu>
            <a class="dropdown-item" href="javascript: void(0);" (click)="zoomTo(node)"><i class="mdi mdi-map-search-outline font-size-16 align-middle me-1"></i>Phóng tới</a>
            <a class="dropdown-item" href="javascript: void(0);"><i class="fa-solid fa-sliders font-size-16 align-middle me-1"></i>Điều chỉnh độ trong</a>
            <a class="dropdown-item" href="javascript: void(0);"><i class="mdi mdi-table-headers-eye font-size-16 align-middle me-1"></i>Xem dữ liệu</a>
            <a class="dropdown-item" href="javascript: void(0);" (click)="filter(node)"><i class="mdi mdi-filter-menu-outline font-size-16 align-middle me-1"></i>Lọc dữ liệu</a>
            <a class="dropdown-item" href="javascript: void(0);"><i class="mdi mdi-clipboard-edit-outline font-size-16 align-middle me-1"></i>Thống kê</a>
          </div>
        </div>
      </div> -->


    </div>

    <!-- <span *ngIf="node.level === 0"><i *ngIf="node.icon" class="{{node.icon}} me-1"></i><strong>{{node.data.text}}</strong></span> -->

    <!-- <mat-checkbox class="c-mat-checkbox align-self-center" [checked]="descendantsAllSelected(node)"
      [indeterminate]="descendantsPartiallySelected(node)" (change)="todoItemSelectionToggle(node)">
      <i *ngIf="node.icon" class="{{node.icon}}"></i>
      <span class="fw-500">{{node.data.name}}</span>
    </mat-checkbox> -->

    <!-- <button mat-icon-button (click)="addNewItem(node)">
      <i class="fa-solid fa-plus text-dark"></i>
    </button> -->
  </mat-tree-node>
</mat-tree>

<!-- Copyright 2022 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at https://angular.io/license -->